<app-loading-spinner [active]="loadingContent"></app-loading-spinner>

<div class="row no-gutters">
    <div class="col-12 offset-lg-1 col-lg-11">

        <app-loading-spinner [active]="loading"></app-loading-spinner>

        <ng-container>
            <div class="row" *ngIf="!loading">
                <div class="col-12 col-lg-7">
                    <span class="basic-content-title">
                        {{representativeAttachments.length > 0 ||
                        attachments.length
                        > 0 ? 'Agora é hora de comprovar as informações
                        inseridas' :
                        'Você não possui documentos para comprovar'}}
                    </span>
                    <app-spacer [bottom]="54"></app-spacer>
                </div>
            </div>


            <ng-container *ngIf="attachments.length > 0">
                <app-attachment-collapse [label]="renderLabel('',false)"
                    [badgeStatus]="getOverallAttachmentStatus()">
                    <div *ngFor="let attachment of attachments; let i = index">
                        <div class="row justify-content-between">
                            <div class="col-12 col-lg-7">
                                <div class="d-flex flex-column">
                                    <div class="table-sum-title d-flex">
                                        <div class="mr-2">
                                            <strong>{{attachment.name}}</strong>
                                        </div>
                                        <div class="ml-2">
                                            <b [class.text-danger]="attachment.required"
                                                [style.font-weight]="attachment.required ? '700' : '500'"
                                                [style.font-size]="attachment.required ? '14px' : '13px'">{{attachment.required
                                                ?
                                                " (obrigatório)" :
                                                " (opcional)"}}</b>
                                        </div>
                                    </div>
                                    <app-spacer [bottom]="8"></app-spacer>
                                    <span
                                        class="table-sum-amount">{{attachment.description}}</span>
                                </div>

                                <app-spacer [bottom]="24"></app-spacer>

                                <div class="row"
                                    *ngIf="attachment.have_due_date">
                                    <div class="col-12">
                                        <h3>
                                            Validade
                                        </h3>
                                    </div>

                                    <div class="col-12 col-lg-5">
                                        <app-masked-input mask="00/00/0000"
                                            [standalone]="true" label="De"
                                            placeholder="dd/mm/aaaa"
                                            (onChange)="handleDateChange($event, 'from', i)"
                                            [hasError]="attachment.isFromInvalid"
                                            [errorText]="getFromDateErrorMessage(attachment)">
                                        </app-masked-input>
                                    </div>
                                    <div class=" col-12 col-lg-5">
                                        <app-masked-input mask="00/00/0000"
                                            [standalone]="true" label="Até"
                                            placeholder="dd/mm/aaaa"
                                            (onChange)="handleDateChange($event, 'to', i)"
                                            [hasError]="attachment.isToInvalid"
                                            [errorText]="getToDateErrorMessage(attachment)">
                                        </app-masked-input>
                                    </div>
                                </div>

                                <div class="row"
                                    *ngIf="getSendedFiles(attachment.id).length > 0">
                                    <div
                                        class="col-12 mb-3 attachments-sent-files-header">
                                        <span class="table-sum-title">
                                            Arquivos enviados
                                        </span>
                                    </div>

                                    <div class="col-12">
                                        <div class="attachments-files-grid">
                                            <div class="attachments-file-card"
                                                *ngFor="let file of getSendedFiles(attachment.id)">
                                                <div
                                                    class="attachments-file-preview">
                                                    <img [src]="getFileIcon(file.file)"
                                                        alt="attachment"
                                                        class="attachments-file-icon">
                                                </div>

                                                <div
                                                    class="attachments-file-info">
                                                    <span
                                                        class="attachments-file-title">
                                                        <strong>{{attachment.name}}</strong>
                                                    </span>
                                                    <span
                                                        class="attachments-file-name"
                                                        [title]="getFileName(file.file)">
                                                        {{getFileName(file.file)}}
                                                    </span>

                                                    <ng-container
                                                        *ngIf="file.type.have_due_date">
                                                        <div
                                                            class="attachments-file-dates">
                                                            <span
                                                                class="attachments-file-date-label">Validade:</span>
                                                            <span
                                                                class="attachments-file-date">
                                                                De:
                                                                {{file.date_due
                                                                | date:
                                                                "dd/MM/yyyy" }}
                                                            </span>
                                                            <span
                                                                class="attachments-file-date">
                                                                Até:
                                                                {{file.end_date_due
                                                                | date:
                                                                "dd/MM/yyyy" }}
                                                            </span>
                                                        </div>
                                                    </ng-container>

                                                    <div
                                                        class="attachments-file-actions">
                                                        <button
                                                            class="attachments-file-action-btn"
                                                            (click)="openFile(file.file)"
                                                            title="Visualizar">
                                                            <i
                                                                class="fa fa-eye"></i>
                                                        </button>
                                                        <button
                                                            class="attachments-file-action-btn attachments-file-action-btn-danger"
                                                            (click)="openDeleteModal(file)"
                                                            title="Excluir">
                                                            <i
                                                                class="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-12 col-lg-5">
                                <div
                                    [class.dropzone-disabled]="attachment.have_due_date && !isDateValid(attachment)">
                                    <app-dropzone
                                        (filesChange)="setFiles(i, $event)"
                                        [disabled]="attachment.have_due_date && !isDateValid(attachment)"
                                        [description]="'O arquivo deve estar no formato PDF, JPG, JPEG, PNG, XLS ou XLSX. (1MB)'">
                                    </app-dropzone>
                                </div>
                                <div *ngIf="attachment.have_due_date && !isDateValid(attachment)"
                                    class="attachments-date-warning mt-2">
                                    <svg-icon
                                        src="assets/images/icon-warning.svg"></svg-icon>
                                    Preencha a data de validade corretamente
                                    para habilitar o upload
                                </div>
                            </div>

                            <ng-container *ngIf="i + 1 !== attachments.length">
                                <div class="col-12">
                                    <app-spacer [bottom]="48"></app-spacer>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </app-attachment-collapse>
            </ng-container>

            <ng-container
                *ngFor="let representativeAttachment of representativeAttachments; let i = index; trackBy: trackByRepresentativeAttachment">
                <app-attachment-collapse
                    [label]="renderLabel(representativeAttachment, true)"
                    [badgeStatus]="getOverallRepresentativeAttachmentStatus(representativeAttachment)">
                    <div
                        *ngFor="let attachment of representativeAttachment.attachments; let idx = index">
                        <div class="row justify-content-between">
                            <div class="col-12 col-lg-7">
                                <div class="d-flex flex-column">
                                    <span
                                        class="table-sum-title"><strong>{{attachment.name}}</strong>
                                        <b class="ml-2"
                                            [class.text-danger]="attachment.required"
                                            [style.font-weight]="attachment.required ? '700' : '500'"
                                            [style.font-size]="attachment.required ? '14px' : '13px'">{{attachment.required
                                            ?
                                            " (obrigatório)" :
                                            " (opcional)"}}</b></span>
                                    <app-spacer [bottom]="8"></app-spacer>

                                    <span
                                        class="table-sum-amount">{{attachment.description}}</span>
                                </div>

                                <app-spacer [bottom]="24"></app-spacer>

                                <div class="row"
                                    *ngIf="attachment.have_due_date">
                                    <div class="col-12">
                                        <h3>
                                            Validade
                                        </h3>
                                    </div>

                                    <div class="col-12 col-lg-5">
                                        <app-masked-input mask="00/00/0000"
                                            [standalone]="true" label="De"
                                            placeholder="dd/mm/aaaa"
                                            (onChange)="handleDateChange($event, 'from', idx, i)"
                                            [hasError]="attachment.isFromInvalid"
                                            [errorText]="getFromDateErrorMessage(attachment)">
                                        </app-masked-input>
                                    </div>
                                    <div class=" col-12 col-lg-5">
                                        <app-masked-input mask="00/00/0000"
                                            [standalone]="true" label="Até"
                                            placeholder="dd/mm/aaaa"
                                            (onChange)="handleDateChange($event, 'to', idx, i)"
                                            [hasError]="attachment.isToInvalid"
                                            [errorText]="getToDateErrorMessage(attachment)">
                                        </app-masked-input>
                                    </div>
                                </div>

                                <div class="row"
                                    *ngIf="getRepresentativeSendedFiles(attachment.id, representativeAttachment.representative.id).length > 0">
                                    <div
                                        class="col-12 mb-3 attachments-sent-files-header">
                                        <span class="table-sum-title">
                                            Arquivos enviados
                                        </span>
                                    </div>

                                    <div class="col-12">
                                        <div class="attachments-files-grid">
                                            <div class="attachments-file-card"
                                                *ngFor="let file of getRepresentativeSendedFiles(attachment.id, representativeAttachment.representative.id)">
                                                <div
                                                    class="attachments-file-preview">
                                                    <img [src]="getFileIcon(file.file)"
                                                        alt="attachment"
                                                        class="attachments-file-icon">
                                                </div>

                                                <div
                                                    class="attachments-file-info">
                                                    <span
                                                        class="attachments-file-title">
                                                        <strong>{{attachment.name}}</strong>
                                                    </span>
                                                    <span
                                                        class="attachments-file-name"
                                                        [title]="getFileName(file.file)">
                                                        {{getFileName(file.file)}}
                                                    </span>

                                                    <ng-container
                                                        *ngIf="file.type.have_due_date">
                                                        <div
                                                            class="attachments-file-dates">
                                                            <span
                                                                class="attachments-file-date-label">Validade:</span>
                                                            <span
                                                                class="attachments-file-date">
                                                                De:
                                                                {{file.date_due
                                                                | date:
                                                                "dd/MM/yyyy" }}
                                                            </span>
                                                            <span
                                                                class="attachments-file-date">
                                                                Até:
                                                                {{file.end_date_due
                                                                | date:
                                                                "dd/MM/yyyy" }}
                                                            </span>
                                                        </div>
                                                    </ng-container>

                                                    <div
                                                        class="attachments-file-actions">
                                                        <button
                                                            class="attachments-file-action-btn"
                                                            (click)="openFile(file.file)"
                                                            title="Visualizar">
                                                            <i
                                                                class="fa fa-eye"></i>
                                                        </button>
                                                        <button
                                                            class="attachments-file-action-btn attachments-file-action-btn-danger"
                                                            (click)="openDeleteModal(file)"
                                                            title="Excluir">
                                                            <i
                                                                class="fa fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-12 col-lg-5">
                                <div
                                    [class.dropzone-disabled]="attachment.have_due_date && !isDateValid(attachment)">
                                    <app-dropzone
                                        (filesChange)="setRepresentativeFiles(i, idx, $event)"
                                        [disabled]="attachment.have_due_date && !isDateValid(attachment)"
                                        [description]="'O arquivo deve estar no formato PDF, JPG, JPEG, PNG, XLS ou XLSX. (1MB)'">
                                    </app-dropzone>
                                </div>
                                <div *ngIf="attachment.have_due_date && !isDateValid(attachment)"
                                    class="attachments-date-warning mt-2">
                                    <svg-icon
                                        src="assets/images/icon-warning.svg"></svg-icon>
                                    Preencha a data de validade corretamente
                                    para habilitar o upload
                                </div>
                            </div>

                            <ng-container
                                *ngIf="i + 1 !== representativeAttachment.attachments.length">
                                <div class="col-12">
                                    <app-spacer [bottom]="48"></app-spacer>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </app-attachment-collapse>
            </ng-container>

        </ng-container>
    </div>
</div>

<!-- Carbon Warning Modal para exclusão de arquivo -->
<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteFile.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>